import React from 'react';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import SafeComponent from '../shared/SafeComponent';
import { LOHP_ROW, MAX_WIDTH_CONTAINER } from '../../utils/constants';
import { COMPANY_LOGOS } from './config';
import CompanyLogo from './CompanyLogo';

import './style.scss';

const TrustedBy = () => (
    <div className={classNames('trusted-by-wrapper', LOHP_ROW)}>
        <div className={classNames('trusted-by', MAX_WIDTH_CONTAINER)}>
            <span className="trusted-by-text"><I18n k="logged_out_homepage.trusted_by.title"/>:</span>
            <ul>
                {
                    COMPANY_LOGOS.map((company, index) => (
                        <CompanyLogo key={index} company={company}/>
                    ))
                }
            </ul>
        </div>
    </div>
);

export { TrustedBy };
export default SafeComponent(TrustedBy);
